import { render, staticRenderFns } from "./ListSellers.vue?vue&type=template&id=e53a4570&scoped=true&"
import script from "./ListSellers.vue?vue&type=script&lang=ts&"
export * from "./ListSellers.vue?vue&type=script&lang=ts&"
import style0 from "./ListSellers.vue?vue&type=style&index=0&id=e53a4570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a4570",
  null
  
)

export default component.exports